export const SET_PAGE_TYPE = 'SET_PAGE_TYPE';

export function setPageType(pageType) {
  return {
    type: SET_PAGE_TYPE,
    pageType
  };
}
